import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function WhyChristianScreen() {
  const { answers, setWhyChristian, next, canContinue } = useFlow();
  const t = useT();

  return (
    <>
      <div className="screen-enter" style={{ flex: 1 }}>
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("setup.whyChristian.eyebrow")}</div>
          <h1 className="screen-head__title">{t("setup.whyChristian.title")}</h1>
          <p className="screen-head__text">{t("setup.whyChristian.text")}</p>
        </header>
        <label className="field">
          <span className="field__label">{t("setup.whyChristian.label")}</span>
          <textarea
            className="field__textarea"
            rows={5}
            maxLength={500}
            placeholder={t("setup.whyChristian.placeholder")}
            value={answers.whyChristian}
            onChange={(e) => setWhyChristian(e.target.value)}
          />
        </label>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.continue")}
        </Button>
      </div>
    </>
  );
}
